module.exports = __webpack_public_path__ + "static/Fontisto-b49ae8ab2dbccb02c4d11caaacf09eab.ttf";